import { Input } from "antd";
import {
  createElement,
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
} from "react";

// Thin wrapper around antd Input.OTP; maps Input.OTP onChange to onValueChange.
const InputOtpField = forwardRef(function InputOtpField(
  {
    value = "",
    onValueChange,
    length = 4,
    mask,
    status,
    disabled,
    className,
    size = "large",
    autoFocus,
  },
  ref,
) {
  const innerRef = useRef(null);

  useImperativeHandle(ref, () => ({
    focus: (opts) => innerRef.current?.focus?.(opts),
    blur: () => innerRef.current?.blur?.(),
    nativeElement: innerRef.current?.nativeElement,
  }));

  useEffect(() => {
    if (status === "error") {
      innerRef.current?.focus?.({ cursor: "start" });
    }
  }, [status]);

  const maskProp = mask === true ? "•" : mask || false;

  return createElement(Input.OTP, {
    ref: innerRef,
    className,
    length,
    size,
    value,
    disabled,
    status,
    mask: maskProp,
    autoFocus,
    onChange: (next) => {
      onValueChange?.(typeof next === "string" ? next : "");
    },
  });
});

export default InputOtpField;
